const TRUE_VALUES = new Set(["true", "1", "yes", "on"]);

const getDefaultDynamicFieldValue = (type: string): any => {
  switch (type) {
    case "boolean":
      return false;
    case "number":
      return 0;
    default:
      return "";
  }
};

export const parseDynamicFieldValue = (value: any, type: string): any => {
  if (!value) {
    return getDefaultDynamicFieldValue(type);
  }

  switch (type) {
    case "boolean": {
      if (typeof value === "boolean") return value;
      if (typeof value === "number") return value !== 0;
      const normalized = String(value).trim().toLowerCase();
      return !['false', '0', 'no'].includes(normalized) && TRUE_VALUES.has(normalized);
    }
    case "number": {
      const num = Number(value);
      return Number.isNaN(num) ? 0 : num;
    }
    default:
      return String(value);
  }
};

export const normalizeDynamicFieldValue = (type: string, value: any): any => {
  return parseDynamicFieldValue(value, type);
};

export const stringifyDynamicFieldValue = (value: any): string => {
  if (!value) {
    return "";
  }
  if (typeof value === "boolean") {
    return value ? "true" : "false";
  }
  if (typeof value === "number") {
    return Number.isFinite(value) ? value.toString() : "0";
  }
  return String(value);
};

export const getDefaultValueForDynamicField = (type: string): any =>
  getDefaultDynamicFieldValue(type);

